// MUI Imports
import {
  Box,
  Button,
  Grid,
  Backdrop,
  CircularProgress,
  Card,
  CardContent,
  Typography,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  InputAdornment,
  MenuItem,
  IconButton,
  Chip
} from "@mui/material";
import Tab from "@mui/material/Tab";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import { DataGrid } from "@mui/x-data-grid";
import { DataGridPro } from '@mui/x-data-grid-pro';
import { useTheme } from "@mui/material";
import { useState } from "react";

// Icon Imports
import Icon from "../../components/icon";
import AddIcon from "@mui/icons-material/Add";
import Tooltip from "@mui/material/Tooltip";


// ** Custom Component Imports
import CustomTextField from "components/mui/text-field";
import CustomAutocomplete from "components/mui/autocomplete";
import CloseIcon from "@mui/icons-material/Close";
import PauseIcon from "@mui/icons-material/Pause";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PaymentIcon from '@mui/icons-material/Payment';
import useMediaQuery from "@mui/material/useMediaQuery";

// ** Third-Party Imports
import { toast, ToastContainer } from "react-toastify";

// ** Component Imports
import AddTeamDialog from "./component/NewTeam";
import AddSkillTypeDialog from "./component/NewSkillType";
import RolesnPerms from "./component/Roles&Perms";
import AddRoleDialog from "./component/NewRole";
import AddSalesTaxDialog from "./component/AddSalesTaxDialog";
import AddTermsNConditionsDialog from "./component/AddTermsNCondtions";
import RoleManagementDialog from "./component/RoleManagement";
import CompanySettingsTab from "./component/CompanySettingsTab";
import InvoiceHistoryDialog from "./component/InvoiceHistoryDialog";
import IndustryTab from "./component/IndustryTab";
import DepartmentTab from "./component/DepartmentTab";
import UnitTab from "./component/UnitofMeasureTab";

// ** Logic Imports
import { useIndexLogic } from "./logic/index-logic";
import { useSettingPermission } from "./permissions/SettingPermissions";

// Layout Imports
import UserLayout from "../../components/layouts/UserLayout";
import MonthlySubscriptionDialog from "screens/Dashboard/component/MonthlySubscriptionDialog";

import { convertESTToLocal, getDateRangeLabelFromEndDate, GetFormatedDateStamp, isPayButtonDisabled } from "components/formatDate";
import { UpdateSubscriptionStatus } from "./logic/UpdateSubscriptionStatus";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import EmbeddableForm from "./component/RequestForm";
import JobTitleTab from "./component/JobTitleTab";

const Settings = () => {
  //#region Permissions
  const MySwal = withReactContent(Swal);
  const { SettingPermissionProps } = useSettingPermission();
  const {
    // Role Permissions
    hasRoleSavePermission,
    hasRoleGetPermission,

    // Team Permissions
    hasTeamSavePermission,
    hasTeamGetPermission,
    hasTeamDeletePermission,

    //Stripe Permissions
    hasStripeGetPermission,

    // Skill Permissions
    hasSkillSavePermission,
    hasSkillDeletePermission,

    // CompanySettings Permissions
    hasCompanyGetPermission,

    // TermsAndConditions Permissions
    hasTnCSavePermission,
    hasTnCGetPermission,
  } = SettingPermissionProps;
  //#endregion Permissions

  const theme = useTheme();
   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [isConnected, setIsConnected] = useState(false);
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [dialogOpen, setDialogOpen] = useState(false);

  const sampleInvoices = [
    { id: 1, invoice: 'INV-001', date: '6/6/2025', amount: '$150.00', status: 'Paid' },
    { id: 2, invoice: 'INV-002', date: '6/6/2025', amount: '$150.00', status: 'Paid' },
    { id: 3, invoice: 'INV-003', date: '6/6/2025', amount: '$150.00', status: 'Paid' },
    { id: 4, invoice: 'INV-004', date: '6/6/2025', amount: '$150.00', status: 'Paid' },
    { id: 5, invoice: 'INV-005', date: '6/6/2025', amount: '$150.00', status: 'Paid' },
  ];
  
  const { IndexProps, RoleProps, SkillProps, TeamProps } = useIndexLogic(toast);
  const {
    contentHeightFixed,
    loading,
    tabValue,
    handleTabChange,
    openSalesTaxDlg,
    openTnCDlg,
    columnsTeam,
    columnsSkillType,
    columnsSalesTaxRate,
    columnsTermsNConditions,
    navigate,
    dummyRowsTnC,
    collapse,
    setCollapse,
    handleCloseSalesTaxDlg,
    handleOpenSalesTaxDlg,
    handleOpenTnCDlg,
    handleCloseTnCDlg,
    tncRows,
    loadingTnc,
    editTnc,
    handleSaveTnC,
    search,
    setSearch,
    filterModule,
    setFilterModule,
    filteredRows,
    MODULES,
    onboardingStatus,
    calculation,
    stripeStatus,
    handleNewStripeConnection,
    handleExistingStripeConnection,
    handleDisconnectStripe,
    accountOption,
    handleCloseStripeConnect,
    connectOpen,
    handleOpenStripeConnect,
    handleManageStripeAccount,
    subscriptionPaymnets,
    invoiceDialogOpen, 
    setInvoiceDialogOpen,
    handleOpenReceipt,
    handleCloseReceipt,
    openReceipt,
    historyLoading,
    setLoading,
    getOnboardingStatus,
  } = IndexProps;

  const {
    rnpTabValue,
    handleRnpTabChange,
    openRoleDlg,
    handleOpenRoleDlg,
    handleCloseRoleDlg,
    openRoleManagement,
    handleOpenRoleManagement,
    handleCloseRoleManagement,
    roles,
    selectedRole,
    handleRoleFilterChange,
    handleSavePermissions,
    isPermChanged,
  } = RoleProps;

  const { skillsList, handleOpenSkillTypeDlg } = SkillProps;

  const { teamsList, handleOpenTeamDlg } = TeamProps;

  const tabList = () => {
    const tabConfig = [
       {
        key: "company-settings",
        value: "1",
        label: "Company Settings",
         icon: "oui:index-settings",
        show: hasCompanyGetPermission,
      },      
      {
        key: "roles-permissions",
        value: "2",
        label: "Roles & Permissions",
         icon: "oui:app-users-roles",
        show: hasRoleGetPermission,
      },
      {
        key: "teams",
        value: "3",
        label: "Teams",
        icon:"ri:team-line",
        show: hasTeamGetPermission,
      },
     
      {
        key: "Stripe Account",
        value: "4",
        label: "Stripe Account",
        icon: "hugeicons:money-bag-02",
        show: hasCompanyGetPermission,
      },
      {
        key: "Subscription Billing",
        value: "5",
        label: "Subscription Billing",
        icon: "si:money-line",
        show: hasCompanyGetPermission,
      },

      {
        key: "terms-conditions",
        value: "6",
        label: "Terms & Conditions",
        icon: "icon-park-outline:notes",
        show: hasTnCGetPermission,
      },
      {
        key: "industries",
        value: "7",
        label: "Industries",
        icon: "tabler:settings-check",
        show: true,
      },
      {
        key: "requestform",
        value: "8",
        label: "Request Form",
        icon: "mdi:code-tags",
        show: true,
      },
       {
        key: "Departments",
        value: "9",
        label: "Departments",
        icon: "arcticons:emoji-department-store",
        show: true,
      },
      {
        key: "unit-of-measure",
        value: "10",
        label: "Unit of Measure",
        icon: "tdesign:measurement",
        show: true,
      },
      {
        key: "job-titles",
        value: "11",
        label: "JobTitles",
        icon: "hugeicons:job-link",
        show: true,
      }

    ];

   return tabConfig
  .filter((tab) => tab.show)
  .map((tab) => (
    <Tab
      key={tab.key}
      value={tab.value}
      label={
        <Box sx={{ 
          display: 'flex',
          alignItems: 'center',
          width: "100%",
          textAlign: "left",
          gap: 2,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          color: theme.palette.mode === 'dark' ? 
            tabValue === tab.value ? "#fff" : "inherit" :
            "inherit"
        }}>
          <Icon 
            icon={tab.icon} 
            width={20} 
            height={20} 
            sx={{ mr: 1 }} 
          />
          {tab.label}
        </Box>
      }
      sx={{ 
        alignItems: "flex-start",
        minHeight: 44,
        padding: '6px 16px'
      }}
    />
  ));
  };

  const nextBillingDate = onboardingStatus?.clientOnBoarding?.subscriptionEndDate;
  const subscriptionStatus = onboardingStatus?.clientOnBoarding?.subscriptionStatus;
  
  // Always derive isPaused from the current subscriptionStatus
  const isPaused = subscriptionStatus === 'Paused';
  const isBillingCycleDue = (date) => date && new Date() >= new Date(date);
  
 
  
  
  const handlePauseSubscription = async () => {
    if(subscriptionStatus === "Active"){
      MySwal.fire({
        title: '<strong>Are you sure?</strong>',
        html: '<span>Pausing? You’ll lose premium access until resumed.</span>',
        showCancelButton: true,
        confirmButtonText: 'Yes, Proceed!',
        cancelButtonText: 'No, Cancel',
        width: '420px', // Explicit width control
        padding: '1rem',
        focusConfirm: false,
        showCloseButton: true,
        closeButtonHtml: '&times;', // This is the × symbol
        customClass: {
          popup: theme.palette.mode === 'dark' ? 'custom-swal-popup-dark' : 'custom-swal-popup',
          title: theme.palette.mode === 'dark' ? 'custom-swal-title-dark' : 'custom-swal-title',
          htmlContainer: 'custom-swal-html',
          confirmButton: 'custom-swal-confirm',
         cancelButton: theme.palette.mode === 'dark' ? 'custom-swal-cancel-dark' : 'custom-swal-cancel',
          closeButton: 'custom-swal-close'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          updateStatus(); 
        }
      });
    }else{
      updateStatus(); 
    }                 
  }

  const updateStatus = async () => {
    setLoading(true);
    try {
      if(subscriptionStatus === "Trial") {
        toast.error("You cannot pause a trial subscription.", {
      style: {
        fontFamily: '"DM Sans", sans-serif',
        fontSize: '15px',
      },
    });
        return;
      }
      
      const newStatus = subscriptionStatus === "Active" ? "Paused" : "Active";
      const response = await UpdateSubscriptionStatus(newStatus, navigate);
      
      if (response?.isError) {
        toast.error(response.message);
      } else {
        toast.success(`Subscription ${newStatus.toLowerCase()} successfully.`);
        await getOnboardingStatus(); // Refresh the data
      }
    } catch(e) {
      console.error("Subscription update error:", e);
      toast.error("Failed to update subscription", {
      style: {
        fontFamily: '"DM Sans", sans-serif',
        fontSize: '15px',
      },
    });
    } finally {
      setLoading(false);
    } 
  }

  return (
    <UserLayout contentHeightFixed={contentHeightFixed} activeLink={"Settings"}>
      <Card sx={{ width: "100%", height: "100%", p: { xs: 1, sm: 2 } }}>
        <CardContent
          sx={{
            p: { xs: 1, sm: 2 },

            "&:last-child": { pb: { xs: 1, sm: 2 } },
          }}
        >
          <TabContext value={tabValue}>
            <Box
              sx={{
                display: { xs: "block", sm: "flex" },
                position: "relative",
                transition: "width 0.3s ease",
                width: "100%",
              }}
            >
              <TabList
                orientation="vertical"
                onChange={handleTabChange}
                sx={{
                  display: collapse ? "none" : "block",
                  minWidth: collapse ? 0 : 220,
                  zIndex: 1,
                }}
              >
                {tabList()}
              </TabList>
              {!isMobile && (
              <Box>
                <IconButton
                  sx={(theme) => ({
                    position: "absolute",
                    left: collapse ? -16 : 203,
                    top: 8,
                    backgroundColor: "#a3e2b9",
                    border: `1px solid ${theme.palette.divider}`,
                    zIndex: 2,
                    width: 30,
                    height: 30,
                    color: "primary.main",
                    transition: "left 0.3s ease",

                    "&:hover": {
                      backgroundColor: "#a3e2b9",
                    },
                  })}
                  size="small"
                  onClick={() => setCollapse(!collapse)}
                >
                  <Icon
                    icon={
                      collapse ? "tabler:chevron-right" : "tabler:chevron-left"
                    }
                  />
                </IconButton>
              </Box>
              )}
              {/* Company Settings Tab */}
              {hasCompanyGetPermission && (
                <TabPanel value="1">
                  <CompanySettingsTab
                    columnsSalesTaxRate={columnsSalesTaxRate}
                    openSalesTaxDlg={openSalesTaxDlg}
                    handleOpenSalesTaxDlg={handleOpenSalesTaxDlg}
                    handleCloseSalesTaxDlg={handleCloseSalesTaxDlg}
                  />
                </TabPanel>
              )}
              {/* Roles & Permissions Tab */}
              {hasRoleGetPermission && (
                <TabPanel
                  value="2"
                  sx={{
                    width: {
                      sm: collapse ? "100%" : "60%",
                      md: collapse ? "100%" : "75%",
                      lg: collapse ? "100%" : "80%",
                      xl: collapse ? "100%" : "84%",
                    },
                    "& .MuiTabPanel-root": {
                      paddingLeft: "0px !important",
                    },
                  }}
                >
                  <Grid container spacing={5} sx={{ overflowX: "auto" }}>
                    <Grid item xs={12}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: { xs: "column", lg: "row" },
                          justifyContent: "space-between",
                          alignItems: { xs: "flex-start", lg: "center" },
                          gap: { xs: 2, sm: 0 },
                        }}
                      >
                        <Box>
                          <Typography variant="h3">
                            Role-Based Access Permissions
                          </Typography>
                          <Typography color="secondary">
                            Manage permissions for different roles in the
                            system.
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: { xs: "column", lg: "row" }, // Stack buttons vertically on mobile
                            gap: 2, // Consistent gap between buttons

                            mt: { xs: 2, lg: 0 }, // Add top margin only on mobile
                          }}
                        >
                          <Button
                            variant="text"
                            color={theme.palette.mode === 'dark' ? "secondary" : "primary"}
                            disabled={!hasRoleSavePermission}
                            {...(hasRoleSavePermission && {
                              onClick: () => handleOpenRoleManagement(),
                            })}
                          >
                            Manage Roles
                          </Button>
                          <Button
                            variant="contained"
                            color="main"
                            {...(hasRoleSavePermission && {
                              onClick: () => handleSavePermissions(),
                            })}
                            disabled={!isPermChanged || !hasRoleSavePermission}
                          >
                            Save Changes
                          </Button>
                          <Button
                            variant="contained"
                            color="main"
                            startIcon={<AddIcon />}
                            disabled={!hasRoleSavePermission}
                            {...(hasRoleSavePermission && {
                              onClick: () => handleOpenRoleDlg(),
                            })}
                          >
                            Create Role
                          </Button>
                        </Box>
                      </Box>
                    </Grid>
                  <Grid item xs={12}>
                      <Box>
                        <CustomTextField
                          fullWidth
                          label="Filter By Role"
                          select
                          value={selectedRole}
                          onChange={(e) =>
                            handleRoleFilterChange(e.target.value)
                          }
                          sx={{
                            maxWidth: "200px",
                          }}
                        >
                          {[...roles] // Create a copy of the array
                            .sort((a, b) => a.roleName.localeCompare(b.roleName))
                            .map((role) => {
                              return (
                                <MenuItem key={role.roleID} value={role.roleID}>
                                  {role.roleName}
                                </MenuItem>
                              );
                            })}
                        </CustomTextField>
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Divider sx={{ py: 3 }} />
                    </Grid>
                    <Grid item xs={12}>
                      <TabContext value={rnpTabValue}>
                        <TabList
                          onChange={handleRnpTabChange}
                          variant="scrollable"
                          scrollButtons="auto"
                        >
                          <Tab
                            value="1"
                            label={
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1.5,
                                  width: "100%",
                                  color: theme.palette.mode === 'dark' ? 
                                    rnpTabValue === "1" ? "#fff" : "inherit" :
                                    "inherit"
                                }}
                              >
                                <Box
                                  sx={{
                                    fontSize: { xs: '0.875rem', md: "1rem" },
                                    fontWeight: 500,
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  Dashboard
                                </Box>
                              </Box>
                            }
                          />
                          <Tab
                            value="2"
                            label={
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1.5,
                                  width: "100%",
                                  color: theme.palette.mode === 'dark' ? 
                                    rnpTabValue === "2" ? "#fff" : "inherit" :
                                    "inherit"
                                }}
                              >
                                <Box
                                  sx={{
                                    fontSize: { xs: '0.875rem', md: "1rem" },
                                    fontWeight: 500,
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  Customers
                                </Box>
                              </Box>
                            }
                          />
                          <Tab
                            value="3"
                            label={
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1.5,
                                  width: "100%",
                                  color: theme.palette.mode === 'dark' ? 
                                    rnpTabValue === "3" ? "#fff" : "inherit" :
                                    "inherit"
                                }}
                              >
                                <Box
                                  sx={{
                                    fontSize: { xs: '0.875rem', md: "1rem" },
                                    fontWeight: 500,
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  Employees
                                </Box>
                              </Box>
                            }
                          />
                          <Tab
                            value="4"
                            label={
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1.5,
                                  width: "100%",
                                  color: theme.palette.mode === 'dark' ? 
                                    rnpTabValue === "4" ? "#fff" : "inherit" :
                                    "inherit"
                                }}
                              >
                                <Box
                                  sx={{
                                    fontSize: { xs: '0.875rem', md: "1rem" },
                                    fontWeight: 500,
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  Requests
                                </Box>
                              </Box>
                            }
                          />
                          <Tab
                            value="5"
                            label={
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1.5,
                                  width: "100%",
                                  color: theme.palette.mode === 'dark' ? 
                                    rnpTabValue === "5" ? "#fff" : "inherit" :
                                    "inherit"
                                }}
                              >
                                <Box
                                  sx={{
                                    fontSize: { xs: '0.875rem', md: "1rem" },
                                    fontWeight: 500,
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  Assessments
                                </Box>
                              </Box>
                            }
                          />
                          <Tab
                            value="6"
                            label={
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1.5,
                                  width: "100%",
                                  color: theme.palette.mode === 'dark' ? 
                                    rnpTabValue === "6" ? "#fff" : "inherit" :
                                    "inherit"
                                }}
                              >
                                <Box
                                  sx={{
                                    fontSize: { xs: '0.875rem', md: "1rem" },
                                    fontWeight: 500,
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  Estimates
                                </Box>
                              </Box>
                            }
                          />
                          <Tab
                            value="7"
                            label={
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1.5,
                                  width: "100%",
                                  color: theme.palette.mode === 'dark' ? 
                                    rnpTabValue === "7" ? "#fff" : "inherit" :
                                    "inherit"
                                }}
                              >
                                <Box
                                  sx={{
                                    fontSize: { xs: '0.875rem', md: "1rem" },
                                    fontWeight: 500,
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  Work Orders
                                </Box>
                              </Box>
                            }
                          />
                          <Tab
                            value="8"
                            label={
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1.5,
                                  width: "100%",
                                  color: theme.palette.mode === 'dark' ? 
                                    rnpTabValue === "8" ? "#fff" : "inherit" :
                                    "inherit"
                                }}
                              >
                                <Box
                                  sx={{
                                    fontSize: { xs: '0.875rem', md: "1rem" },
                                    fontWeight: 500,
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  Attachments
                                </Box>
                              </Box>
                            }
                          />
                          <Tab
                            value="9"
                            label={
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1.5,
                                  width: "100%",
                                  color: theme.palette.mode === 'dark' ? 
                                    rnpTabValue === "9" ? "#fff" : "inherit" :
                                    "inherit"
                                }}
                              >
                                <Box
                                  sx={{
                                    fontSize: { xs: '0.875rem', md: "1rem" },
                                    fontWeight: 500,
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  Dispatch Board
                                </Box>
                              </Box>
                            }
                          />
                          <Tab
                            value="10"
                            label={
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1.5,
                                  width: "100%",
                                  color: theme.palette.mode === 'dark' ? 
                                    rnpTabValue === "10" ? "#fff" : "inherit" :
                                    "inherit"
                                }}
                              >
                                <Box
                                  sx={{
                                    fontSize: { xs: '0.875rem', md: "1rem" },
                                    fontWeight: 500,
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  Invoices
                                </Box>
                              </Box>
                            }
                          />
                          <Tab
                            value="11"
                            label={
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1.5,
                                  width: "100%",
                                  color: theme.palette.mode === 'dark' ? 
                                    rnpTabValue === "11" ? "#fff" : "inherit" :
                                    "inherit"
                                }}
                              >
                                <Box
                                  sx={{
                                    fontSize: { xs: '0.875rem', md: "1rem" },
                                    fontWeight: 500,
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  Payments
                                </Box>
                              </Box>
                            }
                          />
                          <Tab
                            value="12"
                            label={
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1.5,
                                  width: "100%",
                                  color: theme.palette.mode === 'dark' ? 
                                    rnpTabValue === "12" ? "#fff" : "inherit" :
                                    "inherit"
                                }}
                              >
                                <Box
                                  sx={{
                                    fontSize: { xs: '0.875rem', md: "1rem" },
                                    fontWeight: 500,
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  Services
                                </Box>
                              </Box>
                            }
                          />
                          <Tab
                            value="13"
                            label={
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1.5,
                                  width: "100%",
                                  color: theme.palette.mode === 'dark' ? 
                                    rnpTabValue === "13" ? "#fff" : "inherit" :
                                    "inherit"
                                }}
                              >
                                <Box
                                  sx={{
                                    fontSize: { xs: '0.875rem', md: "1rem" },
                                    fontWeight: 500,
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  Inventory
                                </Box>
                              </Box>
                            }
                          />
                          <Tab
                            value="14"
                            label={
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1.5,
                                  width: "100%",
                                  color: theme.palette.mode === 'dark' ? 
                                    rnpTabValue === "14" ? "#fff" : "inherit" :
                                    "inherit"
                                }}
                              >
                                <Box
                                  sx={{
                                    fontSize: { xs: '0.875rem', md: "1rem" },
                                    fontWeight: 500,
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  Settings
                                </Box>
                              </Box>
                            }
                          />
                          <Tab
                            value="15"
                            label={
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1.5,
                                  width: "100%",
                                  color: theme.palette.mode === 'dark' ? 
                                    rnpTabValue === "15" ? "#fff" : "inherit" :
                                    "inherit"
                                }}
                              >
                                <Box
                                  sx={{
                                    fontSize: { xs: '0.875rem', md: "1rem" },
                                    fontWeight: 500,
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  Configuration
                                </Box>
                              </Box>
                            }
                          />
                          {/* <Tab value="7" label="Customer Portal" />
                          <Tab value="8" label="Field App" /> */}
                        </TabList>
                        <TabPanel value="1">
                          <RolesnPerms
                            entity="dashboard"
                            RoleProps={RoleProps}
                          />
                        </TabPanel>
                        <TabPanel value="2">
                          <RolesnPerms
                            entity="customer"
                            RoleProps={RoleProps}
                          />
                        </TabPanel>
                        <TabPanel value="3">
                          <RolesnPerms
                            entity="employee"
                            RoleProps={RoleProps}
                          />
                        </TabPanel>
                        <TabPanel value="4">
                          <RolesnPerms
                            entity="serviceRequest"
                            RoleProps={RoleProps}
                          />
                        </TabPanel>
                        <TabPanel value="5">
                          <RolesnPerms
                            entity="serviceRequest"
                            RoleProps={RoleProps}
                          />
                        </TabPanel>
                        <TabPanel value="6">
                          <RolesnPerms
                            entity="serviceRequest"
                            RoleProps={RoleProps}
                          />
                        </TabPanel>
                        <TabPanel value="7">
                          <RolesnPerms
                            entity="serviceRequest"
                            RoleProps={RoleProps}
                          />
                        </TabPanel>
                        <TabPanel value="8">
                          <RolesnPerms
                            entity="attachments"
                            RoleProps={RoleProps}
                          />
                        </TabPanel>
                        <TabPanel value="9">
                          <RolesnPerms
                            entity="dispatchBoard"
                            RoleProps={RoleProps}
                          />
                        </TabPanel>
                        <TabPanel value="10">
                          <RolesnPerms entity="invoice" RoleProps={RoleProps} />
                        </TabPanel>
                        <TabPanel value="11">
                          <RolesnPerms entity="payment" RoleProps={RoleProps} />
                        </TabPanel>
                        <TabPanel value="12">
                          <RolesnPerms
                            entity="services"
                            RoleProps={RoleProps}
                          />
                        </TabPanel>
                        <TabPanel value="13">
                          <RolesnPerms
                            entity="inventory"
                            RoleProps={RoleProps}
                          />
                        </TabPanel>
                        <TabPanel value="14">
                          <RolesnPerms
                            entity="settings"
                            RoleProps={RoleProps}
                          />
                        </TabPanel>
                        <TabPanel value="15">
                          <RolesnPerms
                            entity="configuration"
                            RoleProps={RoleProps}
                          />
                        </TabPanel>
                      </TabContext>
                    </Grid>
                  </Grid>
                </TabPanel>
              )}
              {/* Teams Tab */}
              {hasTeamGetPermission && (
                <TabPanel value="3" sx={{ width: "100%" }}>
                  <Grid container spacing={10}>
                    <Grid item xs={12}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: { xs: "column", lg: "row" },
                          justifyContent: "space-between",
                          alignItems: { xs: "flex-start", lg: "center" },
                          gap: { xs: 2, lg: 0 },
                        }}
                      >
                        <Box>
                          <Typography variant="h3">Teams</Typography>
                          <Typography color="secondary">
                            Create and manage teams or groups.
                          </Typography>
                        </Box>
                        <Box>
                          <Button
                            variant="contained"
                            color="main"
                            startIcon={<AddIcon />}
                            disabled={!hasTeamSavePermission}
                            {...(hasTeamSavePermission && {
                              onClick: () => handleOpenTeamDlg(),
                            })}
                          >
                            New Team
                          </Button>
                        </Box>
                      </Box>
                      <Divider sx={{ py: 3 }} />
                      <DataGridPro
                        key={
                          collapse
                            ? "collapsed"
                            : !hasTeamDeletePermission
                            ? "DeleteRevoked"
                            : !hasTeamSavePermission
                            ? "SaveRevoked"
                            : "expanded"
                        }
                        autoHeight
                        hideFooter
                        rows={teamsList}
                        columns={columnsTeam}
                        disableRowSelectionOnClick
                        sx={{
                          "& .MuiDataGrid-columnHeaderTitle": {
                            textTransform: "none",
                          },
                        }}
                        slots={{
                          footer: () => null
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: { xs: "column", lg: "row" },
                          justifyContent: "space-between",
                          alignItems: { xs: "flex-start", lg: "center" },
                          gap: { xs: 2, lg: 0 },
                        }}
                      >
                        <Box>
                          <Typography variant="h3">Skill Types</Typography>
                          <Typography color="secondary">
                            Manage skill types with employee counts and rates.
                          </Typography>
                        </Box>
                        <Box>
                          <Button
                            variant="contained"
                            color="main"
                            startIcon={<AddIcon />}
                            disabled={!hasSkillSavePermission}
                            {...(hasSkillSavePermission && {
                              onClick: () => handleOpenSkillTypeDlg(),
                            })}
                          >
                            New Skill Type
                          </Button>
                        </Box>
                      </Box>
                      <Divider sx={{ py: 3 }} />
                      <DataGridPro
                        key={
                          collapse
                            ? "collapsed"
                            : !hasSkillDeletePermission
                            ? "DeleteRevoked"
                            : !hasSkillSavePermission
                            ? "SaveRevoked"
                            : "expanded"
                        }
                        autoHeight
                        hideFooter
                        rows={skillsList}
                        columns={columnsSkillType}
                        disableRowSelectionOnClick
                        sx={{
                          maxWidth: { sm: "100%" },
                          "& .MuiDataGrid-columnHeaderTitle": {
                            textTransform: "none",
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                </TabPanel>
              )}
              {/* Stripe Account Tab */}
              {hasRoleGetPermission && (
                <TabPanel
                  value="4"
                  sx={{
                    width: {
                      sm: collapse ? "100%" : "60%",
                      md: collapse ? "100%" : "75%",
                      lg: collapse ? "100%" : "80%",
                      xl: collapse ? "100%" : "84%",
                    },
                    "& .MuiTabPanel-root": {
                      paddingLeft: "0px !important",
                    },
                  }}
                >
                  <Grid container spacing={5} sx={{ overflowX: "auto" }}>
                    <Grid item xs={12}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: { xs: "column", sm: "row" },
                          justifyContent: "space-between",
                          alignItems: { xs: "flex-start", sm: "center" },
                          gap: { xs: 2, sm: 0 },
                        }}
                      >
                        <Box>
                          <Typography variant="h3">Stripe Account</Typography>
                          <Typography color="secondary" sx={{ mt: 1 }}>
                            This is the method used to collect payments from
                            your Customers.
                          </Typography>
                        </Box>
                        {stripeStatus && (
                          <Box sx={{ display: "flex", gap: 4 }}>
                            <Button
                              variant="outlined"
                              color="primary"
                              onClick={handleOpen}
                              sx={{
                                backgroundColor: "#fff",
                                color: "#6B7280", // Tailwind's gray-500 equivalent
                                borderColor: "#D1D5DB", // Tailwind's gray-300
                              }}
                            >
                              Manage Account
                            </Button>
                            <Dialog
                              open={open}
                              onClose={handleClose}
                              maxWidth="xs"
                              fullWidth
                            >
                              <DialogTitle sx={{ pb: 2, position: "relative" }}>
                                {/* Close Icon in top-right corner */}
                                <IconButton
                                  onClick={handleClose}
                                  size="small"
                                  sx={{
                                    position: "absolute",
                                    top: 8,
                                    right: 8,
                                  }}
                                >
                                  <CloseIcon />
                                </IconButton>

                                {/* Title */}
                                <Typography variant="h4" sx={{ pr: 4 }}>
                                  Manage Stripe Account
                                </Typography>

                                {/* Subtitle */}
                                <Typography
                                  variant="body1"
                                  color="textSecondary"
                                  sx={{ mt: 4, pr: 2 }}
                                >
                                  You will be redirected to your Stripe
                                  dashboard to manage your account settings.
                                </Typography>
                              </DialogTitle>

                              {/* Spacer between text and buttons */}
                              <Box sx={{ height: 24 }} />

                              <DialogActions sx={{ px: 3, pb: 3, mt: 3 }}>
                                <Button
                                  variant="outlined"
                                  onClick={handleClose}
                                  sx={{
                                    backgroundColor: "#fff",
                                    color: "#6B7280",
                                    borderColor: "#D1D5DB",
                                  }}
                                >
                                  Cancel
                                </Button>
                                <Button
                                  variant="contained"
                                  color="main"
                                  // sx={{ backgroundColor: '#00B86B', color: '#fff', '&:hover': { backgroundColor: '#00A55E' } }}
                                  onClick={handleManageStripeAccount}
                                >
                                  Stripe Dashboard
                                </Button>
                              </DialogActions>
                            </Dialog>
                          </Box>
                        )}
                      </Box>
                      <Divider sx={{ pt: 2 }} />
                    </Grid>
                    <Grid item xs={12}>
                      {!stripeStatus ? (
                        <Card
                          sx={{
                            p: 3,
                            backgroundColor: theme.palette.mode === 'dark' ? '#1B2431' : "#F5F5F5",
                            boxShadow: "none",
                            border: "1px solid",
                            borderColor: "divider",
                            mb: 2,
                          }}
                        >
                          <Box sx={{ mt: 2, mb: 2, ml: 2 }}>
                            <Typography variant="h5" gutterBottom>
                              Stripe Integration
                            </Typography>
                            <Typography variant="body1" color="text.secondary">
                              Connect your Stripe account to process payments
                            </Typography>
                          </Box>
                        </Card>
                      ) : (
                        <Card
                          sx={{
                            p: 5,
                            backgroundColor: "#EBF9F3",
                            boxShadow: "none",
                            border: "1px solid",
                            borderColor: "divider",
                            mb: 2,
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "flex-start",
                              gap: 3,
                              mt: 3,
                              mb: 1,
                            }}
                          >
                            {/* Icon with circular background */}
                            <Box
                              sx={{
                                flexShrink: 0,
                                bgcolor: "#E0F0EA",
                                width: 50,
                                height: 50,
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <Icon
                                icon="eva:checkmark-circle-outline"
                                width={30}
                                height={30}
                                color="#23A26D"
                              />
                            </Box>

                            {/* Text content and button */}
                            <Box sx={{ flex: 1 }}>
                              <Typography variant="h5" color="#23A26D">
                                Stripe Connected Successfully!
                              </Typography>
                              <Typography
                                variant="body1"
                                color="#23A26D"
                                sx={{ mb: 2, opacity: 0.9 }}
                              >
                                Your Stripe account has been successfully
                                connected to our platform. You can now start
                                accepting payments.
                              </Typography>
                            </Box>
                          </Box>
                        </Card>
                      )}

                      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                        {!stripeStatus ? (
                          <Button
                            variant="contained"
                            color="main"
                            // sx={{ textTransform: 'none', px: 3, py: 1 }}
                            onClick={() => handleOpenStripeConnect()}
                          >
                            Connect Account
                          </Button>
                        ) : (
                          <Button
                            variant="outlined"
                            // color="primary"
                            sx={{
                              backgroundColor: "#fff",
                              color: "#6B7280", // Tailwind's gray-500 equivalent
                              borderColor: "#D1D5DB", // Tailwind's gray-300
                            }}
                            onClick={() => handleDisconnectStripe()}
                          >
                            Disconnect Account
                          </Button>
                        )}
                      </Box>
                    </Grid>
                  </Grid>
                </TabPanel>
              )}
              {/*Subscription Billing Tab*/}
              {hasRoleGetPermission && (
                <TabPanel
                  value="5"
                  sx={{
                    width: {
                      sm: collapse ? "100%" : "60%",
                      md: collapse ? "100%" : "75%",
                      lg: collapse ? "100%" : "80%",
                      xl: collapse ? "100%" : "84%",
                    },
                    "& .MuiTabPanel-root": {
                      paddingLeft: "0px !important",
                    },
                  }}
                >
                  <Grid container spacing={5} sx={{ overflowX: "auto" }}>
                    <Grid item xs={12}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: { xs: "column", sm: "row" },
                          justifyContent: "space-between",
                          alignItems: { xs: "flex-start", sm: "center" },
                          gap: { xs: 2, sm: 0 },
                        }}
                      >
                        <Box>
                          <Typography variant="h3">
                            Current Billing Cycle
                          </Typography>
                          <Typography color="secondary">
                            Your subscription details and current charges.
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            gap: 4,
                            mt: { xs: 2, sm: 0 },
                            width: { xs: "100%", sm: "auto" },
                            flexDirection: { xs: "column", sm: "row" },
                            alignItems: { xs: "flex-start", sm: "center" },
                          }}
                        >
                          <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => setInvoiceDialogOpen(true)}
                            sx={{
                              backgroundColor: theme.palette.mode === 'dark' ? '#1B2431' : "#fff",
                              color: theme.palette.mode === 'dark' ? 'rgba(208, 212, 241, 0.68)' : "#6B7280",
                              borderColor: "rgba(208, 212, 241, 0.2)",
                              "&:hover": {
                                backgroundColor: "#fff", // Same as default
                                color: "#6B7280", // Same as default
                                borderColor: "#D1D5DB", // Same as default
                              },
                            }}
                            startIcon={
                              <Icon
                                icon="hugeicons:invoice"
                                width={20}
                                height={20}
                              />
                            }
                          >
                            Payment History
                          </Button>

                         <Tooltip
                            title={
                              subscriptionStatus === "Trial"
                                ? "You're currently on a free trial"
                                : subscriptionStatus === "Active"
                                  ? `You've paid the current month's bill. This option will be available at the start of the next billing cycle. Next billing cycle starts on ${convertESTToLocal(nextBillingDate)}`
                                  : ""
                            }
                          >
                            <span>
                              <Button
                                variant="contained"
                                color="main"
                                disabled={!(
                                  ['Trial', 'Expired'].includes(subscriptionStatus)
                                )}
                                startIcon={<PaymentIcon />}
                                onClick={() => setDialogOpen(true)}
                              >
                                Pay Now  {subscriptionStatus === "Trial" &&  (
                                  <Chip label={subscriptionStatus} size="small" sx={{ ml: 1 }} />  
                                )}                              
                                                                
                              </Button>
                            </span>
                          </Tooltip>
                        </Box>
                      </Box>
                      <Divider sx={{ width: "100%", my: 2 }} />
                    </Grid>

                    {/* Cards Container */}
                    <Grid container spacing={2} sx={{ width: "100%", pl: 5 }}>
                      {/* Active Users Card */}
                      <Grid item xs={12}>
                        <Card
                          sx={{
                            p: 5,
                            mt: 2,
                            border: "1px solid",
                            borderColor: "divider",
                            width: "100%",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: { xs: "column", sm: "row" },
                              justifyContent: "space-between",
                              alignItems: {
                                xs: "flex-start",
                                sm: "flex-start",
                              },
                              gap: { xs: 3, sm: 0 },
                            }}
                          >
                            <Box>
                              <Typography
                                variant="body2"
                                sx={{
                                  display: "inline-block",
                                  bgcolor: "#ECF1FD",
                                  color: "#003A70",
                                  borderRadius: "16px",
                                  px: 2.5,
                                  py: 0.5,
                                  mb: 1,
                                  fontSize: "0.75rem",
                                  lineHeight: 1.5,
                                }}
                                gutterBottom
                              >
                                Active Users Overview
                              </Typography>
                              <Typography
                                variant="h3"
                                sx={{ fontWeight: 600, color: "#003A70" }}
                                gutterBottom
                              >
                                {calculation?.numberOfUsers || "1"}
                              </Typography>
                              <Typography
                                variant="body1"
                                color="#003A70"
                                sx={{ fontWeight: 500 }}
                              >
                                Current Billing Cycle :{" "}
                                {getDateRangeLabelFromEndDate(
                                  nextBillingDate,
                                  subscriptionStatus
                                )}
                              </Typography>
                            </Box>
                              {(subscriptionStatus === "Paused" || subscriptionStatus === "Active") && (
                            <Tooltip
                              title={
                                isPaused
                                  ? "Click to resume your subscription"
                                  : "Click to pause your subscription"
                              }
                              componentsProps={{
                                tooltip: {
                                  sx: {
                                    bgcolor: isPaused
                                      ? "#23A26D"
                                      : "error.main",
                                    color: "common.white",
                                    "& .MuiTooltip-arrow": {
                                      color: isPaused
                                        ? "#23A26D"
                                        : "error.main",
                                    },
                                  },
                                },
                              }}
                            >
                              <Button
                                variant="outlined"
                                startIcon={
                                  isPaused ? <PlayArrowIcon /> : <PauseIcon />
                                }
                                sx={{
                                  mt: { xs: 2, sm: 0 },
                                  ml: { xs: 0, sm: 2 },
                                  width: { xs: "100%", sm: "auto" },
                                  borderColor: isPaused
                                    ? "#23A26D"
                                    : "error.main",
                                  color: isPaused ? "#23A26D" : "error.main",
                                  "&:hover": {
                                    borderColor: isPaused
                                      ? "#23A26D"
                                      : "error.main",
                                    backgroundColor: "transparent",
                                  },
                                }}
                                onClick={handlePauseSubscription}
                              >
                                {isPaused
                                  ? "Resume Subscription"
                                  : "Pause Subscription"}
                              </Button>
                              
                            </Tooltip>
                              )
                            }
                          </Box>
                        </Card>
                      </Grid>

                      {/* Pricing Cards */}
                      <Grid item xs={12} md={6}>
                        <Card
                          sx={{
                            p: 5,
                            height: "100%",
                            border: "1px solid",
                            borderColor: "divider",
                            width: "100%",
                          }}
                        >
                          <Box>
                            <Typography
                              variant="body2"
                              sx={{
                                display: "inline-block",
                                bgcolor: "#F5F5F5",
                                color: "#23A26D",
                                borderRadius: "16px",
                                px: 2.5,
                                py: 0.5,
                                mb: 1,
                                fontSize: "0.75rem", // makes text smaller
                                lineHeight: 1.5,
                              }}
                              gutterBottom
                            >
                              Base Price
                            </Typography>
                            <Typography
                              variant="h3"
                              sx={{ fontWeight: 600, color: "#23A26D" }}
                              gutterBottom
                            >
                              $100{" "}
                              <Typography
                                component="span"
                                variant="body1"
                                color="#23A26D"
                                sx={{ opacity: 0.6 }}
                              >
                                /month
                              </Typography>
                            </Typography>
                            <Typography
                              variant="body2"
                              color="text.secondary"
                              sx={{ fontWeight: 550 }}
                              paragraph
                            >
                              Includes one User
                            </Typography>
                            <Typography variant="body2" paragraph>
                              Gives us a fighting chance to provide solid
                              support and a perfect product. We don't paywall
                              any features; enjoy full access.
                            </Typography>
                            <Divider sx={{ my: 2 }} />
                            <Typography
                              variant="body2"
                              sx={{
                                color: "text.secondary",
                                display: "flex",
                                alignItems: "center",
                                mt: 4,
                              }}
                            >
                              <Icon
                                icon="tabler:progress-check"
                                width={18}
                                height={18}
                                style={{ marginRight: 4, color: "#23A26D" }}
                              />
                              All Features Included
                            </Typography>
                          </Box>
                        </Card>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Card
                          sx={{
                            p: 5,
                            height: "100%",
                            border: "1px solid",
                            borderColor: "divider",
                            width: "100%",
                          }}
                        >
                          <Box>
                            <Typography
                              variant="body2"
                              sx={{
                                display: "inline-block",
                                bgcolor: "#ECF1FD",
                                color: "#003A70",
                                borderRadius: "16px",
                                px: 2.5,
                                py: 0.5,
                                mb: 1,
                                fontSize: "0.75rem", // makes text smaller
                                lineHeight: 1.5,
                              }}
                              gutterBottom
                            >
                              Active User Price
                            </Typography>
                            <Typography
                              variant="h3"
                              sx={{ fontWeight: 600, color: "#003A70" }}
                              gutterBottom
                            >
                              $20{" "}
                              <Typography
                                component="span"
                                variant="body1"
                                color="#003A70"
                                sx={{ opacity: 0.6 }}
                              >
                                /month
                              </Typography>
                            </Typography>
                            <Typography
                              variant="body2"
                              color="text.secondary"
                              sx={{ fontWeight: 550 }}
                              paragraph
                            >
                              Each additional Active User
                            </Typography>
                            <Typography variant="body2" paragraph>
                              Cleri keeps track and informs you when anyone logs
                              in for more than 5 minutes each month, marking
                              that User as "Active"
                            </Typography>
                            <Divider sx={{ my: 2 }} />
                            <Typography
                              variant="body2"
                              sx={{
                                color: "text.secondary",
                                display: "flex",
                                alignItems: "center",
                                mt: 4,
                              }}
                            >
                              <Icon
                                icon="tabler:progress-check"
                                width={18}
                                height={18}
                                style={{ marginRight: 4, color: "#23A26D" }}
                              />
                              All Features Included
                            </Typography>
                          </Box>
                        </Card>
                      </Grid>
                    </Grid>
                  </Grid>
                </TabPanel>
              )}
              {/* Terms & Conditions Tab */}
              {hasTnCGetPermission && (
                <TabPanel value="6" sx={{ width: "100%" }}>
                  <Grid container spacing={5}>
                    <Grid item xs={12}>
                      <Typography variant="h3">
                        Terms and Conditions Management
                      </Typography>
                      <Typography color="secondary">
                        Manage your company's Terms and Conditions
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Divider />
                    </Grid>
                    <Grid item xs={12}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: { xs: "column", lg: "row" }, // Stack on mobile, row on desktop
                          alignItems: { xs: "flex-start", lg: { xs: "flex-start", lg: "center" } },
                          justifyContent: "space-between",
                          gap: 3, 
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: { xs: "column", lg: "row" },
                            alignItems: { xs: "flex-start", lg: "center" },
                            gap: 2,
                              width: { xs: "100%", sm: "auto" }, // Full width container on mobile
                          }}
                        >
                          <CustomTextField
                            fullWidth
                            placeholder="Search Terms & Conditions"
                            value={search}
                            disabled={!hasTnCGetPermission}
                            {...(hasTnCGetPermission && {
                              onChange: (e) => setSearch(e.target.value),
                            })}
                            sx={{
                              minWidth: "255px",
                            }}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <Icon icon="tabler:search" />
                                </InputAdornment>
                              ),
                            }}
                          />
                        <CustomTextField
                              fullWidth
                              select
                              value={filterModule}
                              disabled={!hasTnCGetPermission}
                              {...(hasTnCGetPermission && {
                                onChange: (e) => setFilterModule(e.target.value),
                              })}
                              sx={{
                                minWidth: "200px",
                              }}
                            >
                              <MenuItem value="all">All Modules</MenuItem>
                              {[...MODULES] 
                                .sort((a, b) => a.label.localeCompare(b.label))
                                .map((mod) => (
                                  <MenuItem key={mod.value} value={mod.value}>
                                    {mod.label}
                                  </MenuItem>
                                ))}
                            </CustomTextField>
                        </Box>
                        <Button
                          variant="contained"
                          color="main"
                          startIcon={<AddIcon />}
                          disabled={!hasTnCSavePermission}
                          {...(hasTnCSavePermission && {
                            onClick: () => handleOpenTnCDlg(),
                          })}
                        >
                          Terms & Conditions
                        </Button>
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      <DataGridPro
                        key={collapse ? "collapsed" : "expanded"}
                        autoHeight
                        rowSelection={false}
                        rows={filteredRows}
                        rowHeight={62}
                        columns={columnsTermsNConditions}
                        loading={loadingTnc}
                        sx={{
                          "& .MuiDataGrid-columnHeaderTitle": {
                            textTransform: "none",
                          },
                        }}
                        hideFooter
                      />
                    </Grid>
                  </Grid>
                </TabPanel>
              )}
              {/* Industry Tab */}
              <TabPanel value="7">
                <IndustryTab />
              </TabPanel>
              <TabPanel value="9">
                <DepartmentTab />
              </TabPanel>
              <TabPanel value="10">
                <UnitTab />
              </TabPanel>
              <TabPanel value="11">
                <JobTitleTab />
              </TabPanel>
              {/* RequestForm Tab */}
              <TabPanel value="8">
                <EmbeddableForm/>
              </TabPanel>
            </Box>
          </TabContext>
        </CardContent>
      </Card>

      <Dialog
        open={connectOpen}
        onClose={handleCloseStripeConnect}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ pb: 2, position: "relative" }}>
          {/* Close Icon in top-right corner */}
          <IconButton
            onClick={handleCloseStripeConnect}
            size="small"
            sx={{ position: "absolute", top: 8, right: 8 }}
          >
            <CloseIcon />
          </IconButton>

          {/* Title */}
          <Typography variant="h4" sx={{ pr: 4 }}>
            Connect Stripe Account
          </Typography>

          {/* Subtitle */}
          <Typography
            variant="body1"
            color="textSecondary"
            sx={{ mt: 4, pr: 2 }}
          >
            You will be redirected to Stripe to connect with us.
          </Typography>
        </DialogTitle>

        <Box sx={{ mb: 3, padding: 3 }}>
          <Box sx={{ display: "flex", gap: 2 }}>
            {/* Existing Account Button */}
            <Button
              fullWidth
              onClick={() => handleExistingStripeConnection()}
              sx={{
                p: 2,
                border: "2px solid",
                borderColor:
                  accountOption === "existing" ? "#23A26D" : "#e0e0e0",
                borderRadius: 2,
                minHeight: 140, // Increased from 100 to 140
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textTransform: "none",
                color: "text.primary",
                bgcolor: "background.paper",
                transition: "border-color 0.2s ease",
                "&:hover": {
                  bgcolor: "background.paper",
                },
              }}
            >
              <Box
                sx={{
                  mb: 1,
                  bgcolor: "rgba(35, 162, 109, 0.12)",
                  p: 1.5,
                  borderRadius: "50%",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Icon
                  icon="pajamas:user"
                  width={22}
                  height={22}
                  style={{
                    color: "#23A26D",
                  }}
                />
              </Box>
              <Typography variant="h6" gutterBottom>
                I have an account
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Sign in to your existing Stripe account to continue
              </Typography>
            </Button>

            {/* New Account Button */}
            <Button
              fullWidth
              onClick={() => handleNewStripeConnection()}
              sx={{
                p: 2,
                border: "2px solid",
                borderColor: accountOption === "new" ? "#23A26D" : "#e0e0e0",
                borderRadius: 2,
                minHeight: 140,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textTransform: "none",
                color: "text.primary",
                bgcolor: "background.paper",
                transition: "border-color 0.2s ease",
                "&:hover": {
                  bgcolor: "background.paper",
                },
              }}
            >
              <Box
                sx={{
                  mb: 1,
                  bgcolor: "rgba(35, 162, 109, 0.12)",
                  p: 1.5,
                  borderRadius: "50%",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Icon
                  icon="solar:user-id-linear"
                  width={23}
                  height={23}
                  style={{
                    color: "#23A26D",
                  }}
                />
              </Box>
              <Typography variant="h6" gutterBottom>
                I'm new to Stripe
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Create a new Stripe account in just a few minutes
              </Typography>
            </Button>
          </Box>
        </Box>

        <DialogActions sx={{ px: 3, pb: 3, mt: 3 }}>
          <Button
            variant="outlined"
            onClick={handleCloseStripeConnect}
            sx={{
              backgroundColor: "#fff",
              color: "#6B7280",
              borderColor: "#D1D5DB",
            }}
          >
            Cancel
          </Button>
          {/* <Button
            variant="contained"
            color="main"
          // sx={{ backgroundColor: '#00B86B', color: '#fff', '&:hover': { backgroundColor: '#00A55E' } }}
          // onClick={handleConnect}
          >
            Connect to Stripe
          </Button> */}
        </DialogActions>
      </Dialog>

      <AddRoleDialog
        open={openRoleDlg}
        handleClose={handleCloseRoleDlg}
        RoleProps={RoleProps}
      />
      <RoleManagementDialog
        open={openRoleManagement}
        handleClose={handleCloseRoleManagement}
        RoleProps={RoleProps}
      />

      <AddTeamDialog {...TeamProps} navigate={navigate} toast={toast} />

      <AddSkillTypeDialog {...SkillProps} navigate={navigate} toast={toast} />

      {/* <AddSalesTaxDialog open={openSalesTaxDlg} handleClose={handleCloseSalesTaxDlg} /> */}
      <AddTermsNConditionsDialog
        open={openTnCDlg}
        handleClose={handleCloseTnCDlg}
        onSave={handleSaveTnC}
        initialData={editTnc}
        MODULES={MODULES}
      />
      <InvoiceHistoryDialog
        open={invoiceDialogOpen}
        onClose={() => setInvoiceDialogOpen(false)}
        invoices={subscriptionPaymnets}
        handleOpenReceipt={handleOpenReceipt}
        handleCloseReceipt={handleCloseReceipt}
        openReceipt={openReceipt}
        historyLoading={historyLoading}
      />
      <MonthlySubscriptionDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      />

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      {/* <AddSalesTaxDialog 
        open={openSalesTaxDlg}
        handleClose={handleCloseSalesTaxDlg}
      /> */}

      {/*<ToastContainer />*/}
    </UserLayout>
  );
};

export default Settings;
